import styled from "styled-components";
import { img } from "../../assets/icon";
import { device } from "../../stylesheet/breakpoints";

type Props = {
  image?: string;
  isActive?: boolean
};

export const Thumb = styled.div<Props>`
  position: relative;
  display: inline-grid;
  align-items: end;
  min-width: 80px;
  /* max-width: 130px; */
  width: 100%;

  min-height: 40px;
  max-height: 60px;
  padding: 10px;

  border-radius: 3px;
  background: var(--black);
  background-image: linear-gradient(
      to top,
      RGBA(0, 0, 0, 0.4),
      RGBA(0, 0, 0, 0.4)
    ),
    url(${({ image }) => (image ? image : img)});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;

  @media ${device.desktop} {
    min-width: 150px;
    max-width: 170px;
    min-height: 60px;
    height: 60px;
  }

  ${({ isActive }) => (isActive ? `
    cursor: pointer;
    ` : '')})
`;

export const Decor = styled.div`
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    overflow: hidden;
    pointer-events: none;

    &::before {
      content:"";
      position: absolute;
      top: -3px;
      left: -70px;
      width: 40px;
      height: calc(100% + 6px);
      background-color: rgba(255,255,255, .3);
      transform: skewX(-30deg);
      animation: slideDecor 3.5s infinite linear;
  }

  @keyframes slideDecor {
    0% {
      left: -70px;
    }
    20%, 100% {
      left: calc(100% + 25px);
    }
  }
`;

export const Text = styled.p`
  text-align: start;
  font-weight: 600; //500
  font-size: 10px; //8
  line-height: 1;
  color: var(--white); //var(--button-text-color);
`;

export const Icon = styled.span`
  position: absolute;
  top: -3px; //10
  right: -3px; //10
  color: var(--white); //var(--button-text-color);
`;
